export default {"src":"/_next/static/media/show.9d517cea.svg","height":24,"width":28};